import { IRootState } from '../../../store'

export const getCookieSelector = (state: IRootState): string => state.cookie.cookie
